import * as React from 'react'
import {Time, Util} from 'yougile-util'
import {TaskData} from 'yougile-model'
import {StickerPanelProps} from '@components/sticker/sticker-panel/types'
import {Sync} from '../../../client/sync'
import {withUpdaters} from '../../../containers/updaters'
import {SimpleUpdater} from '../../../containers/updaters/simple-updater'
import {SyncUpdater} from '../../../containers/updaters/sync-updater'
import {globals} from '../../../extensions/globals-base'
import {UserProxy} from '../../../extensions/proxies/user-proxy'
import {ByUserBase} from './by-user-base'
import {getAllCards} from './by-user-card'
import {ByUserFilter, ByUserFilterNotifier} from './by-user-filter'
import {
  getAssignDateSticker,
  getProjectSticker,
  getUserSticker
} from './by-user-stickers'

const state: {
  update: () => void
  start?: number
  stop?: number
  tasks?: TaskData[]
  lastRequest?: number
  lastSyncUpdate?: number
  errors?: Set<number>
} = {update: Util.noop}

const syncUpdater = () =>
  SyncUpdater({
    companyType: 'current',
    filter: '*',
    debounceTime: 1000,
    beforeUpdate: () => {
      state.lastSyncUpdate = Time.now()
      if (state.errors) {
        state.errors.clear()
      }
    }
  })

// update state.lastSyncUpdate even if <ByUser/> is not mounted
syncUpdater().onMount(() => {
  if (state.update) {
    state.update()
  }
})

export const ByUser = withUpdaters(
  SimpleUpdater(
    upd => {
      state.update = upd
      ByUserFilterNotifier.onChange(upd)
    },
    () => (state.update = undefined)
  )
)(() => {
  const companyId = globals.getCompanyId()
  const box = Sync.getCurrentSandbox()
  const dateFilter = ByUserFilter.getDates()

  const start = dateFilter ? Time.startOfDay(dateFilter[0]) : undefined
  const stop = dateFilter ? Time.endOfDay(dateFilter[1]) : undefined

  if (
    !state.tasks ||
    start !== state.start ||
    stop !== state.stop ||
    state.lastRequest < state.lastSyncUpdate
  ) {
    state.tasks = getAllCards(start, stop)

    state.lastRequest = Time.now()
    state.start = start
    state.stop = stop
  }
  const userFilter = ByUserFilter.getUsers()
  const projectFilter = ByUserFilter.getProjects()

  const users = box
    .getAllUsers(false)
    .filter(u => u && (userFilter.length === 0 || userFilter.includes(u.id)))
    .map(x => UserProxy.create(x))

  const filteredTasks = !state.tasks
    ? []
    : state.tasks
        .filter(
          task =>
            userFilter.length === 0 ||
            !!userFilter.find(uid => task.assigned.includes(uid))
        )
        .filter(
          task =>
            projectFilter.length === 0 || projectFilter.includes(task.projectId)
        )

  const emulated: StickerPanelProps['emulated'] = {
    companyId,
    stickers: [
      getAssignDateSticker(companyId),
      getUserSticker(companyId),
      getProjectSticker(companyId)
    ],
    filter: ByUserFilter
  }

  return <ByUserBase emulated={emulated} tasks={filteredTasks} users={users} />
})
